export const linkedProductsKey = (productId_1: string, productId_2: string) => `${productId_1}:${productId_2}`

export const parseLinkedProductsKey = (key: string) => {
    const [productId_1, productId_2] = key.split(':')
    return {
        productId_1,
        productId_2
    }
}
